import { snakeToCamel } from '@eventbrite/string-utils';
import { QuestionId } from '../../api/models/survey';
import { getFieldPrefilledValue } from '../../api/transformations/survey';
import { getFieldName } from '../../containers/checkout/constants';
import { CheckoutState } from '../../state';
import { getNamespaceValue } from '../utils/selector';
import { getQuestionsCollection } from './pureSelectors';

export const getSurveyResponseNameValues = (state: CheckoutState) => {
    const interactiveQuestionsByAttendeeId = getNamespaceValue(
        state.survey,
        'interactiveQuestionsByAttendeeId',
        {},
    );
    const surveyResponsesByAttendeeId = getNamespaceValue(
        state.survey,
        'surveyResponsesByAttendeeId',
        {},
    );

    const existingQuestionsByAttendee = Object.entries(
        interactiveQuestionsByAttendeeId,
    ).reduce<Record<string, Set<QuestionId>>>(
        (otherAttendees, [attendeeId, interactiveQuestions]) => ({
            ...otherAttendees,
            [attendeeId]: new Set(
                interactiveQuestions.map(({ questionId }) => questionId),
            ),
        }),
        {},
    );

    const questionsCollection = getQuestionsCollection(state);

    return Object.entries(surveyResponsesByAttendeeId)
        .flatMap(([attendeeId, attendeeResponses = {}]) =>
            Object.entries(attendeeResponses).map(
                ([surveyFieldRawName, surveyFieldValue]) => ({
                    attendeeId,
                    surveyFieldRawName,
                    surveyFieldValue,
                }),
            ),
        )
        .filter(({ attendeeId, surveyFieldRawName }) =>
            existingQuestionsByAttendee[attendeeId]?.has(surveyFieldRawName),
        )
        .reduce<Record<string, string>>(
            (acc, { attendeeId, surveyFieldRawName, surveyFieldValue }) => ({
                ...acc,
                ...(surveyFieldValue
                    ? {
                          [getFieldName(attendeeId, surveyFieldRawName)]:
                              getFieldPrefilledValue({
                                  value: surveyFieldValue,
                                  type: questionsCollection[
                                      snakeToCamel(surveyFieldRawName)
                                  ].type,
                              } as Parameters<typeof getFieldPrefilledValue>[0]) as string,
                      }
                    : {}),
            }),
            {},
        );
};
